/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Boris Kudla� (kudlac@cadwork.cz)
 *
 */

import ViewMode from "App/view/modes/view_mode";
import {vec2} from "gl-matrix";
import View from "App/view/view";
// we need the ts because otherwise the enum inside is not exported as tsx argue that no out is emmit for that file.
// We can use export const enum, but in this case tsc is ok with that, but on enum is exported at all
//@ts-ignore
import {ViewModeEnum} from "js_interface/src/modules/view_mode/scene_view_mode_enums";
import RenderDocument from "App/render_document";

export default
class ViewModeQuad extends ViewMode {
    constructor(aRenderDocument: RenderDocument) {
        super(aRenderDocument);

        let viewLB = new View(this, this.rdocument, vec2.fromValues(0, 0), vec2.fromValues(50, 50));
        let viewRB = new View(this, this.rdocument, vec2.fromValues(50, 0), vec2.fromValues(50, 50));
        let viewLT = new View(this, this.rdocument, vec2.fromValues(0, 50), vec2.fromValues(50, 50));
        let viewRT = new View(this, this.rdocument, vec2.fromValues(50, 50), vec2.fromValues(50, 50));

        this.addView(viewLB);
        this.addView(viewRB);
        this.addView(viewLT);
        this.addView(viewRT);

        this.createLights();

        this.activeView = viewLB;
    }

    public getModeType(): ViewModeEnum {
        return ViewModeEnum.QUAD;
    }
}
